import request from '@/utils/zsm-requets'
let qa='/zsm/api/qa/'
/**
 *  获取单个问题
 */
export function getQa(id) {
  return request({
    url: qa+'get',
    method: 'post',
    params: {id}
  })
}

/* 获取问题列表
    qaDict 类型
 */
export function listDataQa(params) {
  return request({
    url: qa+'listData',
    method: 'post',
    params
  })
}



/* 问题赞或踩

   type 0踩 1赞
   id  问题
 */
export function scoreQa(params) {
  return request({
    url: qa+'score',
    method: 'post',
    params
  })
}
